import nacl from 'tweetnacl';
import naclUtil from 'tweetnacl-util';

function canonicalize(value) {
  if (Array.isArray(value)) {
    return `[${value.map(canonicalize).join(',')}]`;
  }
  if (value && typeof value === 'object') {
    return `{${Object.keys(value)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${canonicalize(value[key])}`)
      .join(',')}}`;
  }
  return JSON.stringify(value);
}

export function actionSigningPayload(action) {
  const { signature: _signature, ...unsigned } = action;
  return canonicalize(unsigned);
}

export function signGameAction(action, signingSecretKey) {
  const bytes = naclUtil.decodeUTF8(actionSigningPayload(action));
  const signature = nacl.sign.detached(bytes, signingSecretKey);
  return {
    ...action,
    signature: naclUtil.encodeBase64(signature)
  };
}

export function verifyGameAction(action, signingPublicKey) {
  if (!action?.signature || !signingPublicKey) {
    return false;
  }
  try {
    return nacl.sign.detached.verify(
      naclUtil.decodeUTF8(actionSigningPayload(action)),
      naclUtil.decodeBase64(action.signature),
      naclUtil.decodeBase64(signingPublicKey)
    );
  } catch {
    return false;
  }
}

export function previousMoveSignature(game) {
  return game.moves.at(-1)?.signature || null;
}
